import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function CloseIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.43909 2.41842C3.8812 1.86053 2.97668 1.86053 2.41879 2.41842C1.86089 2.97631 1.86089 3.88083 2.41879 4.43872L9.98006 12L2.41879 19.5613C1.86089 20.1192 1.86089 21.0237 2.41879 21.5816C2.97668 22.1395 3.8812 22.1395 4.43909 21.5816L12.0004 14.0203L19.5616 21.5816C20.1195 22.1395 21.0241 22.1395 21.5819 21.5816C22.1398 21.0237 22.1398 20.1192 21.5819 19.5613L14.0207 12L21.5819 4.43872C22.1398 3.88083 22.1398 2.97631 21.5819 2.41842C21.0241 1.86053 20.1195 1.86053 19.5616 2.41842L12.0004 9.9797L4.43909 2.41842Z" />
        </SvgIcon>
    );
}

export default CloseIcon;
